var map = {
	"./top1.svg": "8ac6",
	"./top1_edited.svg": "4494",
	"./top2.svg": "721e",
	"./top3.svg": "30e0",
	"./top4.svg": "8c0f",
	"./top5.svg": "374f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3255";